module.exports = __webpack_public_path__ + "static/media/down-arrow.a0a62f93.svg";